import React, { useEffect, useState } from "react";
import "../../Styles/Pages/FarmerDetails.css";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Modal,
  Box,
  Button,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import Topbar from "../../Layouts/Admin_layout/Admin_topbar";
import instance from "../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import "../../Styles/Pages/FarmerDetails.css";
import RoomIcon from "@mui/icons-material/Room";
import kml_icon from "../../Assets/kml_icon.svg"
import excel_icon from '../../Assets/excel_download.jpeg'

export default function FarmerDetails() {
  const { hash } = useParams();
  const navigate = useNavigate();
  const [farmer, setFarmer] = useState([]);
  const [farmerDetails, setFarmerDetails] = useState(null);
  const [updatedFarmerDetails, setUpdatedFarmerDetails] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [kmlFileUrl, setKmlFileUrl] = useState(null);
  const [imageToDelete, setImageToDelete] = useState(null);
  const date = new Date(farmerDetails?.date);
  const options = { year: "numeric", month: "numeric", day: "numeric" };
  const formattedDate = date
    .toLocaleDateString("en-US", options)
    .replace(/\//g, "-");

  const formattedTime = new Date(farmerDetails?.createdAt).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true, // For 12-hour format, set this to false for 24-hour format
  });

  const handleDeleteIconClick = (image) => {
    setImageToDelete(image);
    setOpenDeleteModal(true);
  };

  const fetchFarmerDetails = async () => {
    try {
      const response = await instance.get(
        `/field/getfieldById?field_hash=${hash}`
      );
      console.log(response.data);
      setFarmer(response.data.farmer)
      setFarmerDetails(response.data.data);
      setUpdatedFarmerDetails(response.data.officerCheckout);
      if (response.data.data?.kml_file) {
        setKmlFileUrl(response.data.data.kml_file);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleDownloadKML = () => {
    if (kmlFileUrl) {
      const link = document.createElement("a");
      link.href = kmlFileUrl;
      link.setAttribute("download", "map.kml"); // Set the filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("KML file URL is not available");
    }
  };

  useEffect(() => {
    fetchFarmerDetails();
  }, [hash]);

  const handleDeleteConfirm = () => {
    setOpenDeleteModal(false);
  };

  const handleDeleteCancel = () => {
    setImageToDelete(null);
    setOpenDeleteModal(false);
  };

  const style = {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    borderColor: "none",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };

  if (!farmerDetails) return <div>Loading...</div>;

  return (
    <>
      <div style={{ padding: "20px 20px 0px 0px" }}>
        <Topbar />
      </div>
      <div style={{ padding: "20px 0px 0px 0px" }}>
        <div className="details-container">
          <div className="name-number">
            <div>
              <strong>Farmer Name :</strong> {farmer?.name}
            </div>
            <div>
              <strong>Mobile no :</strong> {farmer?.mobile_no}
            </div>
            <div>
              <strong>Email :</strong> {farmer?.email}
            </div>
            <div>
              <button
                onClick={() => navigate("/admin/Fields")}
                className="back-to-farmers"
              >
                Back
              </button>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              marginLeft: "10px",
              marginBottom: "10px",
              gap: '5px',
              alignItems: 'center',
            }}
          >
            <strong className="name-label">Address :</strong>{" "}
            {farmerDetails.address}{" "}
            <div>
              <Tooltip title="Track location">
                <a style={{ color: '#78c144', marginLeft: '5px' }}
                  href={`https://www.google.com/maps/place/${farmerDetails?.latitude}+${farmerDetails?.longitude}`}
                  target="blank"
                >
                  <RoomIcon />
                </a>
              </Tooltip>
            </div>
            <Tooltip title="Download Xml File">
              <img style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', marginTop: '-5px', alignItems: 'center', width: '24px' }} src={kml_icon} alt="kml_file" onClick={handleDownloadKML} />
            </Tooltip>
            <Tooltip title="Download Excel File">
              <img style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', marginTop: '-5px', alignItems: 'center', width: '30px' }} src={excel_icon} alt="excel_file" onClick={handleDownloadKML} />
            </Tooltip>
          </div>
          <div className="farmer-data-container">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="accordion-summary"
              >
                Date : {formattedDate} (Initial Visit) Time : {formattedTime}
              </AccordionSummary>
              <AccordionDetails className="accordion-details">
                <div>
                  <strong>Sanction :</strong>{" "}
                  {farmerDetails.admit_sanction_given}{" "}
                </div>
                <div>
                  <strong>Acres :</strong> {farmerDetails.area_in_acres}{" "}
                </div>
                <div>
                  <strong>Cluster :</strong> {farmerDetails.cluster_name}{" "}
                </div>
                <div>
                  <strong>Plants Lifted Date :</strong>{" "}
                  {farmerDetails?.date_of_plants_lifted ? (
                    <span>
                      {(() => {
                        const date = new Date(
                          farmerDetails.date_of_plants_lifted
                        );
                        const day = String(date.getDate()).padStart(2, "");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          ""
                        );
                        const year = date.getFullYear();
                        return `${day}-${month}-${year}`;
                      })()}
                    </span>
                  ) : (
                    <span>N/A</span>
                  )}
                </div>
                <div>
                  <strong>District :</strong> {farmerDetails.district_name}{" "}
                </div>
                <div>
                  <strong>Mandal :</strong> {farmerDetails.mandal_name}{" "}
                </div>
                <div>
                  <strong>Village :</strong> {farmerDetails.village_name}{" "}
                </div>
                <div>
                  <strong>Drip dd :</strong> {farmerDetails.drip_dd_paid}{" "}
                </div>
                <div>
                  <strong>Drip survey :</strong> {farmerDetails.drip_survey}{" "}
                </div>
                <div>
                  <strong>Electricity Availability :</strong>{" "}
                  {farmerDetails.electricity_availability}{" "}
                </div>
                <div>
                  <strong>Marking :</strong> {farmerDetails.marking}{" "}
                </div>
                <div>
                  <strong>Plantation dd :</strong> {farmerDetails.plant_dd_paid}{" "}
                </div>
                <div>
                  <strong>Plantation Date :</strong>{" "}
                  {farmerDetails?.plantation_date ? (
                    <span>
                      {(() => {
                        const date = new Date(farmerDetails.plantation_date);
                        const day = String(date.getDate()).padStart(2, "");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          ""
                        );
                        const year = date.getFullYear();
                        return `${day}-${month}-${year}`;
                      })()}
                    </span>
                  ) : (
                    <span>N/A</span>
                  )}
                </div>
                <div>
                  <strong>Plantation Status :</strong>{" "}
                  {farmerDetails.plantation_status}{" "}
                </div>
                <div>
                  <strong>Plants Lifted :</strong> {farmerDetails.plants_lifted}{" "}
                </div>
                <div>
                  <strong>Registration Status:</strong>{" "}
                  {farmerDetails.registration_status}{" "}
                </div>
                {farmerDetails.registration_status === "Done" && (
                  <div>
                    <strong>Survey Number:</strong> {farmerDetails.registration_no}{" "}
                  </div>
                )}
                <div>
                  <strong>Source Of Water:</strong> {farmerDetails.source_of_water}{" "}
                </div>
                {farmerDetails.source_of_water === "BoreWell" && (
                  <div>
                    <strong>Borewell Count :</strong>{" "}
                    {farmerDetails.number_of_borewell}{" "}
                  </div>
                )}
                <div>
                  <strong>Type of Customer :</strong>{" "}
                  {farmerDetails.type_of_customer}{" "}
                </div>
                <div>
                  <strong>Ownership Type :</strong> {farmerDetails.ownership_type}{" "}
                </div>
              </AccordionDetails>
              <div className="images-updated-container">
                <div>
                  <strong>Picture of Marking :</strong>
                  <div className="document">
                    <div className="image-container">
                      <img loading="lazy"
                        className="document-images"
                        src={farmerDetails.picture_of_marking}
                        alt="documents"
                      />
                      {/* <DeleteIcon
                        className="delete-icon"
                        onClick={() =>
                          handleDeleteIconClick(
                            farmerDetails.picture_of_marking
                          )
                        }
                      /> */}
                    </div>
                  </div>
                </div>
                <div>
                  <strong>Picture of Plantation :</strong>
                  <div className="document">
                    <div className="image-container">
                      <img loading="lazy"
                        className="document-images"
                        src={farmerDetails.picture_of_plantation}
                        alt="plantation_images"
                      />
                      {/* <DeleteIcon
                        className="delete-icon"
                        onClick={() =>
                          handleDeleteIconClick(
                            farmerDetails.picture_of_plantation
                          )
                        }
                      /> */}
                    </div>
                  </div>
                </div>
                <div>
                  <strong>Documents</strong>
                  <div className="document">
                    <div className="image-container">
                      {farmerDetails.image_of_document.length
                        ? farmerDetails.image_of_document.map((item, index) => (
                          <div key={index}>
                            <img loading="lazy"
                              className="document-images"
                              src={item}
                              alt="document"
                            />
                            {/* <DeleteIcon
                                className="delete-icon"
                                onClick={() => handleDeleteIconClick()}
                              /> */}
                          </div>
                        ))
                        : "no Images"}
                    </div>
                  </div>
                </div>
              </div>
            </Accordion>
          </div>
          {updatedFarmerDetails.length
            ? updatedFarmerDetails.map((farmer) => (
              <div className="farmer-data-container">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="accordion-summary"
                  >
                    {farmer?.createdAt ? (
                      <span>
                        {(() => {
                          const date = new Date(farmer.createdAt);
                          const day = String(date.getDate()).padStart(2, "0");
                          const month = String(date.getMonth() + 1).padStart(2, "0");
                          const year = date.getFullYear();

                          const hours = date.getHours();
                          const minutes = String(date.getMinutes()).padStart(2, "0");

                          const ampm = hours >= 12 ? "PM" : "AM";
                          const formattedHours = hours % 12 || 12; // Convert 24-hour time to 12-hour format

                          const formattedDate = `${day}-${month}-${year}`;
                          const formattedTime = `${formattedHours}:${minutes} ${ampm}`;

                          return `Date : ${formattedDate} Time : ${formattedTime}`;
                        })()}
                      </span>
                    ) : (
                      <span>Date: N/A</span>
                    )}
                  </AccordionSummary>
                  <AccordionDetails className="details-updated">
                    <div>
                      <strong className="name-label">Description :</strong>{" "}
                      {farmer.description}{" "}
                    </div>
                    <div>
                      <strong className="name-label">Field Health :</strong>{" "}
                      {farmer.feild_health}{" "}
                    </div>
                    <div>
                      <strong>Application Remarks :</strong>{" "}
                      {farmer.fertilization_application_remark}{" "}
                    </div>
                    <div>
                      <strong>Observation :</strong>{" "}
                      {farmer.inflorescence_observation}{" "}
                    </div>
                    <div>
                      <strong>Irrigation Remarks :</strong>{" "}
                      {farmer.irrigation_remarks}{" "}
                    </div>
                    <div>
                      <strong>Leafs :</strong> {farmer.number_of_leafs}{" "}
                    </div>
                    <div>
                      <strong>Pest Remarks :</strong> {farmer.pest_remarks}{" "}
                    </div>
                    <div>
                      <strong>Plant Length :</strong> {farmer.plant_length}{" "}
                    </div>
                    <div>
                      <strong>Plant Width :</strong> {farmer.plant_width}{" "}
                    </div>
                  </AccordionDetails>
                  <div className="images-updated-container">
                    <div>
                      <strong>Pest Pictures </strong>{" "}
                      <div className="document">
                        <div className="image-container">
                          <img loading="lazy"
                            className="document-images"
                            width={100}
                            height={100}
                            src={farmer.pest_pictures}
                            alt="pest_pictures"
                          />{" "}
                        </div>
                      </div>
                    </div>
                    <div>
                      <strong>Plant Picture </strong>{" "}
                      <div className="document">
                        <div className="image-container">
                          <img loading="lazy"
                            className="document-images"
                            width={100}
                            height={100}
                            src={farmer.plant_picture}
                            alt="documents"
                          />{" "}
                        </div>
                      </div>
                    </div>
                    <div>
                      <strong>Selfie with Farmer </strong>{" "}
                      <div className="document">
                        <div className="image-container">
                          <img loading="lazy"
                            className="document-images"
                            width={100}
                            height={100}
                            src={farmer.selfie_with_field}
                            alt="selfie_of_farmer"
                          />
                          {""}
                        </div>
                      </div>
                    </div>
                    <div>
                      <strong>Field Pictures</strong>
                      <div className="document">
                        <div className="image-container">
                          {farmer.field_Pictures?.length
                            ? farmer.field_Pictures.map((item, index) => (
                              <div key={index}>
                                <img loading="lazy"
                                  className="document-images"
                                  width={100}
                                  height={100}
                                  src={item}
                                  alt="document"
                                />
                                {/* <DeleteIcon
                                    className="delete-icon"
                                    onClick={() => handleDeleteIconClick()}
                                  /> */}
                              </div>
                            ))
                            : "no Images"}
                        </div>
                      </div>
                    </div>
                  </div>
                </Accordion>
              </div>
            ))
            : null}
          <Modal
            open={openDeleteModal}
            onClose={handleDeleteCancel}
            aria-labelledby="delete-modal-title"
            aria-describedby="delete-modal-description"
          >
            <Box sx={style}>
              <div id="delete-modal-title">
                Do you want to delete this image ?
              </div>
              <div id="delete-modal-description">
                <Button
                  variant="contained"
                  className="yes"
                  onClick={handleDeleteConfirm}
                >
                  Yes
                </Button>
                <Button
                  variant="contained"
                  className="no"
                  onClick={handleDeleteCancel}
                >
                  No
                </Button>
              </div>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}
